<style lang="scss" scoped>
.custom-back-top {
  position: absolute;
  bottom: 40px;
  right: 70px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  color: #fff;
  font-size: 24px;
  padding: 0 12px 2px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
}

.sltpprice:hover {
  /*text-decoration: underline;*/
  cursor: pointer;
  background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.trades {
  position: relative;
  height: 100%;
  margin-bottom: 10px;
  padding-top: 5px;
  font-size: 14px;
  text-align: left;
}

.trades_advanced {
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  padding-bottom: 0;
}

hr {
  border: 1px solid var(--color-background);
  /*border-top: 1px double darkgray;*/
  border-top: none;
  /*color: #333;*/
  overflow: visible;
  text-align: center;
  height: 0px;
  margin: 10px -20px;
}

.table-header {
  position: sticky;
  top: 0;
  background-color: var(--color-card);
  padding-top: 10px;
}

.table-wrapper {
  margin-right: -20px;
  overflow: auto;
}

.red {
  color:var(--color-danger-light);
  /*color: orangered;*/
}

.green {
  color: var(--color-success-light);
}

td {
  /*border: 1px solidvar(--color-danger-light);*/
}

div {
  /*border: 1px dotted limegreen;*/
}

.inline {
  display: inline-block;
}

table {
  /*table-layout:fixed;*/
}

.outer {
  /*color : red;*/
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  /*mask-image: rgba(0,0,0,1);*/
  /*mask-image: -webkit-gradient(linear, left top, right bottom,*/
  /*color-stop(0.00,  rgba(0,0,0,1)),*/
  /*color-stop(0.35,  rgba(0,0,0,1)),*/
  /*color-stop(0.50,  rgba(0,0,0,0)),*/
  /*color-stop(0.65,  rgba(0,0,0,0)),*/
  /*color-stop(1.00,  rgba(0,0,0,0)));*/
}

.notrades {
  /*font-weight: bold;*/
  text-align: center;
  padding-top: 20px;
  /*color: #958b9a;*/
  color: var(--color-neutral);
  font-size: 16px;
}

.headerTable {
  text-align: left;
  font-size: 11px;
}

.headerCellText {
  vertical-align: bottom;
  margin-bottom: 7px;
  display: inline-block;
  width: 55px;
}

.leftText {
  width: 45px;
}

.headerTableCell {
  vertical-align: bottom;
}

.filterStatusSelect {
  width: 220px;
}

.action:hover {
  /*color: var(--color-accent-dark);*/
  /*text-decoration: underline;*/
  background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fname {
  font-size: 12px;
  /*font-weight: bold;*/
  color: var(--color-accent-dark);
  /*text-decoration: underline;*/
}

.table-headers-div {
  font-size: 8px;
  display: inline-block;
  color: var(--color-text-dark);
  font-weight: bold;
  padding-right: 2px;
}

.headerviolet {
  font-size: 12px;
  color: var(--color-text-dark);
  font-weight: bold;
  /*padding-right: 2px*/
}

.padleft {
  padding-left: 20px;
}

.filterBox {
  display: grid;
  grid-template-columns: 179px 1fr 2fr 1fr 2fr 1fr;
  grid-template-rows: repeat(2, 1fr);
  align-items: center;
  grid-gap: 10px;
  margin-top: 10px;
}

.filterHeader {
  /*display: flex;*/
  /*justify-content: flex-end;*/
  padding-top: 2px;
  text-align: right;
  font-size: 11px;
}

.trade-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 3fr 30px;
  grid-gap: 5px;
  grid-template-areas: 'symbol qty bar buttons';
}

@media all and (min-width: 1001px) {
  #line {
    display: none;
  }
}

@media all and (max-width: 1000px) {
  .trade-grid {
    grid-template-columns: 1fr 1fr 30px;
    grid-template-rows: 1fr 1px 1fr;
    grid-template-areas:
      'symbol qty buttons'
      'line line buttons'
      'bar bar buttons';
  }
}

#line {
  grid-area: line;
}
#symbol {
  grid-area: symbol;
}
#qty {
  grid-area: qty;
}
#buttons {
  grid-area: buttons;
}
#bar {
  grid-area: bar;
}

.table-names {
  /*font-size: 8px;*/
  color: var(--color-text-dark);
  font-weight: bold;
}
.tablerow {
  background-color: var(--color-card-dark);
}
.oddrow {
  background-color: var(--color-card);
}
.hist-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 15px;
  align-items: center;
}
.comment {
  cursor: pointer;
}
.comment:hover {
  color: #8c8eba;
  /*text-decoration: underline;*/
}

.centerhor {
  display: flex;
  justify-content: center;
}

.sort-header {
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
}
</style>

<template>
  <div :class="{ outer: $store.state.trades.loading }">
    <EditCommentModal @on-cancel="$store.state.editCommentModal.show = false" />
    <OpenOrdersModal @on-cancel="$store.state.openOrdersModal.show = false" />
    <TradeOrdersModal
      :show="tradeOrdersModalShow"
      :orders="tradeOrders"
      :symbol="tradeSymbol"
      :comment="tradeComment"
      :side="tradeSide"
      @on-cancel="tradeOrdersModalShow = false"
    />
    <Confirm
      :show="confirmCancelModal"
      :subtitle="confirmSubtitle"
      :text="confirmText"
      :btname="confirmBtnName"
      @on-cancel="confirmCancelModal = false"
      @confirmed="cancelTrade(confirmTradeId, confirmStatus)"
    />
    <Confirm
        :show="confirmCancelTradeModal"
        :headerText="confirmText"
        :subtitle="confirmSubtitle"
        :text="$text.tr('Будут отменены все неисполненные ордера в данной сделке. Активы и открытые позиции останутся на бирже.')"
        :btname="confirmBtnName"
        @on-cancel="confirmCancelTradeModal = false"
        @confirmed="cancelTrade(confirmTradeId, confirmStatus)"
        :warning="true"
    />
    <Confirm
      :show="confirmSellModal"
      :headerText="confirmText"
      :subtitle="confirmSubtitle"
      :text="$text.tr('Позиция будет закрыта по рыночной цене и сделка перейдет в историю. Все неисполненные ордера будут отменены.')"
      :btname="confirmBtnName"
      @on-cancel="confirmSellModal = false"
      @confirmed="sell(confirmTradeId, confirmStatus)"
      :warning="true"
    />
    <Confirm
      :show="confirmSellAllModal"
      :text="confirmText"
      :btname="confirmBtnName"
      @on-cancel="confirmSellAllModal = false"
      @confirmed="sellAll()"
    />
    <Confirm
      :show="confirmCancelAllTradesModal"
      :headerText="$text.tr('Выключить все выбранные сделки?')"
      :text="$text.tr('Будут отменены все неисполненные ордера во всех выбранных сделках. Активы и открытые позиции останутся на бирже.')"
      :btname="$text.tr('ДА')"
      :warning="true"
      @on-cancel="confirmCancelAllTradesModal = false"
      @confirmed="cancelAllFilteredTrades()"
    />
    <ConfirmRebuy
      :show="confirmRebuy"
      :trade="tradeRebuy"
      @on-cancel="hideConfirmRebuy"
      @rebought="hideConfirmRebuy"
    />
    <div
      class="box symbbox trades"
      :class="{ trades_advanced: advanced }"
    >
      <div :class="{ 'table-header': advanced }">
        <div class="filterBox">
          <div>
            <RadioGroup
              v-model="$store.state.trades.filt.type"
              type="button"
              size="default"
              @on-change="
                ;($store.state.trades.loading = true),
                  $store.dispatch('updateTrades')
              "
            >
              <Radio
                label="act"
                style="font-size: 12px"
              >{{
                $text.tr('АКТИВНЫЕ')
              }}</Radio>
              <Radio
                label="hist"
                style="font-size: 12px"
              >{{
                $text.tr('ИСТОРИЯ')
              }}</Radio>
            </RadioGroup>
          </div>
          <div class="filterHeader">
            {{ $text.tr('ДАТЫ') }}
          </div>
          <div>
            <DatePicker
              v-model="$store.state.trades.dates"
              style="font-size: 14px; width: 100%"
              type="daterange"
              placement="bottom-end"
              format="dd.MM.yyyy"
              :placeholder="$text.tr('Выбрать период')"
              @on-change="saveDatePickerDates"
            ></DatePicker>
          </div>
          <div class="filterHeader">
            {{ $text.tr('КОЛ-ВО') }}
          </div>
          <div>
            <Select
              v-model="$store.state.trades.limit"
              style="font-size: 18px; max-width: 150px"
              size="default"
            >
              <Option
                v-for="lim1 in limits"
                :value="lim1"
                :key="lim1"
                style="font-size: 18px"
              >{{ lim1 }}</Option>
            </Select>
          </div>
          <div>
            <Tooltip
              v-if="showCloseBtn"
              :delay="1000"
              placement="top"
              :content="$text.tr('Сбросить фильтры')"
            >
              <Button
                v-if="showCloseBtn"
                type="text"
                size="small"
                @click="resetFilter"
                style="padding: 0px"
              >
                <Icon
                  type="ios-close-circle-outline"
                  size="25"
                  style="color: var(--color-text)"
                />
              </Button>
            </Tooltip>
          </div>
          <div>
            <i-input
              v-model="searchTxt"
              @on-keydown="searchCanceled($event)"
              clearable
              :placeholder="$text.tr('поиск')"
              style="width: 100%"
            ></i-input>
          </div>
          <div class="filterHeader">
            {{ $text.tr('СТАТУС') }}
          </div>
          <div>
            <Select
              v-if="$store.state.trades.filt.type === 'act'"
              v-model="$store.state.trades.filt.stat"
              size="default"
            >
              <Option
                v-for="(status, index) in actStatuses"
                :value="status.en"
                :key="'act-' + index"
                style="font-size: 18px"
              >{{ $text.tr(status.ru) }}</Option>
            </Select>
            <Select
              v-else
              v-model="$store.state.trades.filt.stat"
              size="default"
            >
              <Option
                v-for="(stat2, index) in historyStatuses"
                :value="stat2.en"
                :key="'hist-' + index"
              >{{ $text.tr(stat2.ru) }}</Option>
            </Select>
          </div>
          <div class="filterHeader">
            {{ $text.tr('СТОРОНА') }}
          </div>
          <div>
            <Select
              v-model="$store.state.trades.filt.side"
              size="default"
              style="max-width: 150px"
            >
              <Option
                v-for="(side, index) in sides"
                :value="side.en"
                :key="'side' + index"
              >{{ $text.tr(side.ru) }}</Option>
            </Select>
          </div>
          <div style="padding-left: 4px; display: flex; align-items: center">
            <Checkbox
              v-model="symbolFilter"
              size="large"
            ></Checkbox>
            <div style="font-size: 11px; min-width: 60px">
              {{ $text.tr('ФИЛЬТР ПО ПАРЕ') }}
            </div>
          </div>
        </div>
        <div style="
              font-size: 16px;
              margin-bottom: 10px;
              margin-top: 15px;
              display: flex;
              align-items: baseline;
              justify-content: space-between;
            ">
          <div>
            <span
              style="padding-left: 2px"
              class="headerviolet"
            >{{
              $text.tr('СДЕЛОК')
            }}</span>
            {{ $store.state.trades.data.Total }} [<span class="green">{{
              $store.state.trades.data.Green
            }}</span>/<span class="red">{{ $store.state.trades.data.Red }}</span>]
            <span v-if="$store.state.trades.filt.type === 'act'"><span class="headerviolet padleft">{{ $text.tr('СУММА') }}</span>
              <span
                style="padding-left: 4px"
                :title="$text.tr('Текущая сумма средств по всем сделкам')"
                :class="{
                  'blur-balance-span': $store.state.sys.hideBalances
                }"
              ><span>${{ $store.state.trades.data.InvestedUSD }}</span></span>
              <span class="headerviolet padleft">PNL</span>
              <span
                style="padding-left: 4px"
                :title="$text.tr('Общая прибыль по всем сделкам')"
                :class="{
                  ggreen: parseFloat($store.state.trades.data.ProfitUSD) >= 0,
                  gred: parseFloat($store.state.trades.data.ProfitUSD) < 0,
                  'blur-balance-span': $store.state.sys.hideBalances
                }"
              ><span>{{
                  profitDollarSign($store.state.trades.data.ProfitUSD)
                }}</span></span>
              <span class="headerviolet padleft">UPNL</span>
              <span
                style="padding-left: 4px"
                :title="$text.tr('Нереализованная прибыль по всем сделкам')"
                :class="{
                  ggreen: parseFloat($store.state.trades.data.Upnl) >= 0,
                  gred: parseFloat($store.state.trades.data.Upnl) < 0,
                  'blur-balance-span': $store.state.sys.hideBalances
                }"
              ><span>{{
                  profitDollarSign($store.state.trades.data.Upnl)
                }}</span></span>
            </span>
          </div>
          <div style="display: flex; align-items: center; gap: 10px;">
            <button
              class="ghost-btn ghost-btn_small"
              :title="$text.tr('Список ордеров на бирже')"
              @click="showOpenOrdersModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 60 60"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.5 17C4.669 17 4.83583 16.9907 5 16.9725V17H55.5H56V16.9725C58.25 16.7238 60 14.8163 60 12.5C60 10.1837 58.25 8.27619 56 8.02746V8H55.5H5V8.02746C4.83583 8.00932 4.669 8 4.5 8C2.01472 8 0 10.0147 0 12.5C0 14.9853 2.01472 17 4.5 17Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.5 34C4.669 34 4.83583 33.9907 5 33.9725V34H55.5H56V33.9725C58.25 33.7238 60 31.8163 60 29.5C60 27.1837 58.25 25.2762 56 25.0275V25H55.5H5V25.0275C4.83583 25.0093 4.669 25 4.5 25C2.01472 25 0 27.0147 0 29.5C0 31.9853 2.01472 34 4.5 34Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.5 51C4.669 51 4.83583 50.9907 5 50.9725V51H55.5H56V50.9725C58.25 50.7238 60 48.8163 60 46.5C60 44.1837 58.25 42.2762 56 42.0275V42H55.5H5V42.0275C4.83583 42.0093 4.669 42 4.5 42C2.01472 42 0 44.0147 0 46.5C0 48.9853 2.01472 51 4.5 51Z"
                />
              </svg>
            </button>
            <button
              class="ghost-btn ghost-btn_small"
              :disabled="cancelableFilteredTrades.length === 0"
              :title="$text.tr('Выключить все выбранные сделки')"
              @click="confirmCancelAllTradesModal = true"
            >
              <Icon type="md-close" />
            </button>
            <button
              class="ghost-btn ghost-btn_danger ghost-btn_small"
              :disabled="$store.state.trades.data.Trades.length === 0"
              :title="$text.tr('Закрыть все сделки по рынку')"
              @click="showConfirmSellAllModal()"
            >
              <Icon
                type="logo-usd"
              ></Icon>
            </button>
          </div>
        </div>
        <hr />
        <!--        СОРТИРОВКА-->
        <div style="
              width: 100%;
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;
            ">
          <div
            v-for="(sort1, index) in sortBy"
            :key="index + '-' + sort.field"
          >
            <span
              class="sort-header noselect"
              @click="sortClicked(sort1.field)"
            >{{
              $text.tr(sort1.name)
            }}</span>
            <div style="display: inline-block; width: 5px">
              <Icon
                v-if="sort.field === sort1.field && sort.direction === 1"
                type="md-arrow-dropup"
              />
              <Icon
                v-if="sort.field === sort1.field && sort.direction === -1"
                type="md-arrow-dropdown"
              />
            </div>
          </div>
        </div>
        <hr style="margin-bottom: 2px;" />
        <div
          v-if="tradesFiltered.length === 0"
          class="notrades"
        >
          {{ $text.tr('Сделок нет') }}
        </div>
      </div>
      <div
        ref="tableWrapper"
        class="table-wrapper"
      >
        <table
          class="table"
          style="width: 100%; height: 100%;"
        >
          <tr
            v-for="(trade, index) in tradesFiltered"
            :key="index"
            class="tablerow"
            :class="{ oddrow: index % 2 === 0 }"
          >
            <td style="width: 100%; text-align: left; padding: 10px">
              <div class="trade-grid">
                <div id="symbol">
                  <div style="vertical-align: bottom">
                    <div style="
                          vertical-align: bottom;
                          margin-bottom: 3px;
                          height: 20px;
                          width: 20px;
                          display: inline-block;
                        ">
                      <CoinIcon :symbol="trade.Symbol" />
                    </div>
                    <span
                      class="action"
                      v-on:click="editTrade(trade, index)"
                      style="
                          cursor: pointer;
                          font-size: 18px;
                          font-weight: normal;
                        "
                    >
                      {{ trade.Symbol.split('_').join('/') }}
                    </span>
                    <Icon
                      style="vertical-align: text-top; cursor: pointer"
                      type="ios-list-box-outline"
                      size="15"
                      :title="$text.tr('Показать сделки')"
                      color="var(--color-text-dark)"
                      @click="updateTradeOrders(trade)"
                    />
                  </div>
                  <div
                    class="table-names comment"
                    style="font-size: 12px"
                    @click="showEditCommentModal(trade)"
                  >
                    {{ tradeCommentShort(trade) }}
                  </div>
                  <div style="font-size: 12px; display: flex">
                    <div :title="$text.tr('id сделки')" style="cursor: pointer" @click="$copyToClipboardAndNotify(trade.Id)">#{{ trade.Id }}</div>
                    <div
                      style="margin-left: 6px"
                      :title="$text.tr('добавить комментарий')"
                      v-if="!trade.Info || !trade.Info.Comment"
                      class="table-names comment"
                      @click="showEditCommentModal(trade)"
                    >
                      +
                    </div>
                  </div>
                  <div style="font-size: 12px">{{ trade.Created }}</div>
                </div>
                <div id="qty">
                  <table>
                    <tr>
                      <td style="width: 36px"></td>
                      <td>
                        <div
                          v-if="trade.Side === 'B'"
                          style="font-size: 12px"
                          class="green"
                        >
                          {{ $text.tr('покупка') }}
                        </div>
                        <div
                          v-if="trade.Side === 'S'"
                          style="font-size: 12px"
                          class="red"
                        >
                          {{ $text.tr('продажа') }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table-headers-div">
                        {{ $text.tr('КОЛ-ВО') }}
                      </td>
                      <td>
                        <div
                          :class="{
                            'blur-balance': $store.state.sys.hideBalances
                          }"
                          style="display: inline-block"
                        >
                          <div :title="
                              $store.state.trades.filt.type === 'act' &&
                              trade.Info &&
                              parseFloat(trade.Info.QtyLeft) > 0 &&
                              trade.Info.QtyLeft !== trade.Qty
                                ? $text.tr(
                                    'Остаток монет в сделке / Общее кол-во монет в сделке'
                                  )
                                : $text.tr('Кол-во монет в сделке')
                            ">
                            {{
                              $store.state.trades.filt.type === 'act' &&
                              trade.Info &&
                              parseFloat(trade.Info.QtyLeft) > 0 &&
                              trade.Info.QtyLeft !== trade.Qty
                                ? trade.Info.QtyLeft + ' / '
                                : ''
                            }}{{ trade.Qty }}
                          </div>
                        </div>
                        {{ trade.Symbol.split('_')[0] }}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-headers-div">{{ $text.tr('СУММА') }}</td>
                      <td>
                        <div
                          :class="{
                            'blur-balance': $store.state.sys.hideBalances
                          }"
                          style="display: inline-block"
                        >
                          <div v-if="$store.state.trades.filt.type === 'act'" :title="
                              trade.Status !== 'ORDSUBMIT' &&
                              trade.Status !== 'COND'
                                ? $text.tr(
                                    'Сумма выхода по рынку / Инвестировано средств'
                                  )
                                : $text.tr('СУММА ИНВЕСТИЦИЙ').toLowerCase()
                            ">
                            {{
                              trade.Status !== 'ORDSUBMIT' &&
                              trade.Status !== 'COND'
                                ? trade.AmountLeft + ' / '
                                : ''
                            }}{{ trade.Amount }}
                          </div>
                          <div v-else>
                            {{ trade.Amount }}
                          </div>
                        </div>
                        {{ trade.Symbol.split('_')[1] }}
                      </td>
                    </tr>
                    <tr v-if="
                        ($store.state.sys.tradeExchange.ExchId === 'BIF' || $store.getters.isFTXFutures) &&
                          trade.Info &&
                          trade.Info.Leverage
                      ">
                      <td class="table-headers-div">{{ $text.tr('ПЛЕЧО') }}</td>
                      <td>{{ trade.Info.Leverage }}X</td>
                    </tr>
                    <tr v-else-if="trade.Info && trade.Info.MarginType && ($store.state.sys.tradeExchange.ExchId === 'OKX' && trade.Info && trade.Symbol.includes('-PERP') || $store.getters.isBYF || $store.getters.isBitgetFutures)">
                      <td class="table-headers-div">{{ $text.tr('ЗАЛОГ') }}</td>
                      <td>
                        <div
                          :class="{
                            'blur-balance': $store.state.sys.hideBalances
                          }"
                          style="display: inline-block"
                        >
                          <div v-if="$store.getters.isBYF || $store.getters.isBitgetFutures">{{ trade.Info.Margin }} ({{ trade.Info.Leverage }}X)</div>
                          <div v-else>{{ trade.Info.MarginType === 'cross' ? 'CROSS' : trade.Info.Margin }} ({{ trade.Info.Leverage }}X)</div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div id="line">
                  <div style="margin-left: 35px; border-bottom: 1px solid #4a4d73"></div>
                </div>
                <div
                  id="bar"
                  :class="{
                    centerhor: $store.state.trades.filt.type === 'act'
                  }"
                >
                  <div
                    style="
                        height: 70px;
                        display: flex;
                        align-items: center;
                        padding-top: 10px;
                      "
                    v-if="$store.state.trades.filt.type === 'act'"
                  >
                    <ProgressBar
                      :sl="
                        trade.Sltp && trade.Sltp.SlPrice
                          ? trade.Sltp.SlPrice
                          : '0'
                      "
                      :tp="
                        trade.Sltp && trade.Sltp.TpPrice
                          ? trade.Sltp.TpPrice
                          : '0'
                      "
                      :curstep="returnTradeCurStep(trade)"
                      :stepscount="returnTradeStepsLength(trade)"
                      :last="trade.PriceNow"
                      :gray="trade.Status === 'ORDSUBMIT'"
                      :conditional="trade.Status === 'COND'"
                      :profitstr="[
                        trade.Profit,
                        returnQuoteAsset(trade.Symbol)
                      ]"
                      :profitusd="trade.ProfitUSD"
                      :profitpct="calcUnleveragedProfit(trade)"
                      :profitpctlvrg="trade.ProfitPct"
                      :so="returnSoPrice(trade)"
                      :socount="trade.Sos ? trade.Sos.length : 0"
                      :tradeside="trade.Side"
                      :trailing="trade.Sltp && trade.Sltp.Status === 'TPT'"
                      :trade="trade"
                    />
                  </div>
                  <div
                    v-else
                    class="hist-grid"
                  >
                    <div>
                      <table>
                        <tr>
                          <td class="table-headers-div">
                            {{
                              trade.Side === 'B'
                                ? $text.tr('ЦЕНА ПОКУПКИ')
                                : $text.tr('ЦЕНА ПРОДАЖИ')
                            }}
                          </td>
                          <td>{{ trade.Price }}</td>
                        </tr>
                        <tr>
                          <td class="table-headers-div">
                            {{
                              trade.Side === 'B'
                                ? $text.tr('ЦЕНА ПРОДАЖИ')
                                : $text.tr('ЦЕНА ПОКУПКИ')
                            }}
                          </td>
                          <td>
                            {{ trade.SellPrice !== '0' ? trade.SellPrice : '' }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <!--                <div v-if="trade.Status != 'SLSELL' && trade.Status != 'TPSELL' && trade.Status != 'SELL' && trade.Status != 'ASELL' && trade.Status != 'CLOSED' && trade.Status != 'ORDCANCEL' && trade.Status != 'ERROR' && trade.Status !== 'LIQUID'">-->
                      <!--                  <div style="font-size: 7px; display: inline-block; width: 41px">STOP LOSS</div>&nbsp;<span class="sltpprice" @click="editTrade(trade)">{{ trade.Sltp ? trade.Sltp.SlPrice > 0 ? trade.Sltp.SlPrice : "нет" : "нет" }}-->
                      <!--                <span v-if="trade.Sltp && trade.Sltp.SlPrice !== '0' && trade.Sltp.SlTrailPct && trade.Sltp.SlTrailPct !== '0'">trail {{ parseFloat(trade.Sltp.SlTrailPct).toFixed(1) }}%</span></span>-->
                      <!--                  <br>-->
                      <!--                  <div style="font-size: 7px; display: inline-block; width: 41px">TAKE PROFIT</div>&nbsp;<span class="sltpprice" @click="editTrade(trade)">-->
                      <!--                <span v-if="trade.Sltp && trade.Sltp.Status === 'TPT'">Активирован trailing</span>-->
                      <!--                <span v-else-if="trade.Sltp && trade.Sltp.TpPrice > 0">{{ trade.Sltp.TpPrice }}</span>-->
                      <!--                <span v-else>нет</span>-->
                      <!--                <span v-if="trade.Sltp && trade.Sltp.TpPrice !== '0' && trade.Sltp.TpTrailPct && trade.Sltp.TpTrailPct !== '0'">&nbsp;trail {{ trade.Sltp.TpTrailPct }}%</span></span>-->
                      <!--                  <div v-if="trade.Sltp && trade.Sltp.Steps && trade.Sltp.Steps.Steps.length > 1">ступень {{ parseInt(trade.Sltp.Steps.CurStep) + 1 }} из {{ trade.Sltp.Steps.Steps.length }}</div>-->
                      <!--                </div>-->
                      <div v-if="
                          trade.Status === 'SLSELL' ||
                            trade.Status === 'TPSELL' ||
                            trade.Status === 'SELL' ||
                            trade.Status === 'ASELL' ||
                            trade.Status === 'CLOSED' ||
                            trade.Status === 'ORDCANCEL' ||
                            trade.Status === 'ERROR' ||
                            trade.Status === 'LIQUID'
                        ">
                        <span
                          v-if="trade.Status === 'SLSELL' && trade.Side === 'B'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Продано по SL') }}</span>
                        <span
                          v-if="trade.Status === 'TPSELL' && trade.Side === 'B'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Продано по TP') }}</span>
                        <span
                          v-if="trade.Status === 'SLSELL' && trade.Side === 'S'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Куплено по SL') }}</span>
                        <span
                          v-if="trade.Status === 'TPSELL' && trade.Side === 'S'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Куплено по TP') }}</span>
                        <!--                  <span v-if="trade.Status === 'SLSUBM'" style="font-size: 12px; color: var(--color-neutral-light)">Ордер SL размещен</span>-->
                        <!--                  <span v-if="trade.Status === 'TPSUBM'" style="font-size: 12px; color: var(--color-neutral-light)">Ордер TP размещен</span>-->
                        <span
                          v-if="trade.Status === 'ORDCANCEL'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Ордер отменен') }}</span>
                        <span
                          v-if="trade.Status === 'CLOSED'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Сделка выключена') }}</span>
                        <!--                  <span v-if="trade.Status === 'SELLSUBM'" style="font-size: 12px; color: var(--color-neutral-light)">Ордер на продажу размещен</span>-->
                        <span
                          v-if="trade.Status === 'SELL' && trade.Side === 'B'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Продано вручную') }}</span>
                        <span
                          v-if="trade.Status === 'SELL' && trade.Side === 'S'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Выкуплено вручную') }}</span>
                        <span
                          v-if="trade.Status === 'ASELL'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Актив продан вручную') }}</span>
                        <span
                          v-if="trade.Status === 'ERROR'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Ошибка') }}</span>
                        <span
                          v-if="trade.Status === 'LIQUID'"
                          style="font-size: 12px; color: var(--color-neutral-light)"
                        >{{ $text.tr('Ликвидировано') }}</span>
                        <div v-if="trade.Status !== 'ASELL'">
                          <span style="font-size: 12px; color: var(--color-neutral-light)">{{
                            trade.Closed
                          }}</span><br />
                          <span style="font-size: 12px; color: var(--color-neutral-light)">{{
                            trade.Duration
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: right">
                      <!--                <span v-if="trade.Status === 'ORDSUBMIT' && trade.QtyNofee > 0 && trade.QtyNofee !== trade.Qty" style="font-size: 12px;color:  var(--color-neutral)">Частично исполнен {{ trade.QtyNofee }}/{{ trade.Qty }}</span>-->
                      <!--                <span v-else-if="trade.Status === 'ORDSUBMIT'" style="font-size: 12px;color:  var(--color-neutral)">ОРДЕР РАЗМЕЩЕН</span>-->
                      <!--                <span v-if="trade.Status === 'COND'" style="font-size: 12px;color:  var(--color-neutral)">ОТЛОЖЕННЫЙ ОРДЕР</span>-->
                      <div v-if="
                          trade.Status === 'SLTP' ||
                            trade.Status === 'SLSELL' ||
                            trade.Status === 'TPSELL' ||
                            trade.Status === 'SLSUBM' ||
                            trade.Status === 'TPSUBM' ||
                            trade.Status === 'SELLSUBM' ||
                            trade.Status === 'SELL' ||
                            trade.Status === 'LIQUID'
                        ">
                        <span :class="{
                            red: parseFloat(trade.ProfitPct) < 0,
                            green: parseFloat(trade.ProfitPct) >= 0
                          }">
                          {{ !$store.state.sys.hideBalances ? trade.ProfitUSD : '*****' }}
                          <span style="font-size: 10px">USD</span></span><br />
                        <div
                          v-if="parseFloat(trade.ProfitPct) >= 0"
                          class="green"
                        >
                          <span style="font-size: 14px">{{ !$store.state.sys.hideBalances ? trade.Profit : '*****' }}</span><span style="font-size: 10px">
                            {{ trade.Symbol.split('_')[1] }}</span><br />
                        </div>
                        <span
                          v-if="parseFloat(trade.ProfitPct) >= 0"
                          style="font-size: 14px"
                          class="green"
                        >{{ trade.ProfitPct }}%<br /></span>
                        <div
                          v-if="parseFloat(trade.ProfitPct) < 0"
                          class="red"
                        >
                          <span style="font-size: 14px">{{ !$store.state.sys.hideBalances ? trade.Profit : '*****' }}</span><span style="font-size: 10px">
                            {{ trade.Symbol.split('_')[1] }}</span><br />
                        </div>
                        <span
                          v-if="parseFloat(trade.ProfitPct) < 0"
                          style="font-size: 14px"
                          class="red"
                        >{{ trade.ProfitPct }}%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="buttons">
                  <div
                    v-if="
                      trade.Status.substring(2) !== 'SELL' &&
                        trade.Status != 'CLOSED' &&
                        trade.Status != 'ORDCANCEL' &&
                        trade.Status != 'SELLSUBM' &&
                        trade.Status != 'SELL' &&
                        trade.Status != 'ASELL' &&
                        trade.Status != 'ERROR' &&
                        trade.Status !== 'LIQUID'
                    "
                    style="
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        align-items: flex-end;
                        justify-content: space-between;
                      "
                  >
                    <div>
                      <Icon
                        v-if="
                          trade.Status === 'ORDSUBMIT' ||
                            trade.Status === 'COND'
                        "
                        style="cursor: pointer"
                        :title="$text.tr('Отменить')"
                        type="md-close-circle"
                        color="var(--color-text-dark)"
                        size="20"
                        @click="cancelTradeByMode(trade.Id, trade.Status, trade.Symbol)"
                      ></Icon>
                      <Icon
                        v-if="
                          trade.Status !== 'ORDSUBMIT' &&
                            trade.Status !== 'COND' &&
                            (!trade.Symbol.includes('-') || trade.ExchId === 'OKX')
                        "
                        style="cursor: pointer"
                        :title="$text.tr('Выключить умную сделку')"
                        type="md-close"
                        color="var(--color-text-dark)"
                        size="20"
                        @click="cancelTradeByMode(trade.Id, trade.Status, trade.Symbol)"
                      ></Icon>
                      <div
                        v-else
                        style="height: 20px"
                      ></div>
                    </div>
                    <Icon
                      style="cursor: pointer"
                      :title="$text.tr('Редактировать сделку')"
                      type="md-create"
                      color="var(--color-text-dark)"
                      size="19"
                      @click="editTrade(trade, index)"
                    ></Icon>
                    <div v-if="
                        trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND'
                      ">
                      <Icon
                        v-if="trade.Side === 'B'"
                        type="logo-usd"
                        :title="$text.tr('Продать')"
                        color="var(--color-text-dark)"
                        size="18"
                        style="cursor: pointer"
                        @click="sellByMode(trade.Id, 'panicsell', trade.Symbol)"
                      ></Icon>
                      <Icon
                        v-if="trade.Side === 'S'"
                        type="logo-usd"
                        :title="$text.tr('Выкупить')"
                        color="var(--color-text-dark)"
                        size="18"
                        style="cursor: pointer"
                        @click="sellByMode(trade.Id, 'panicbuy', trade.Symbol)"
                      ></Icon>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div
          v-show="isShowBackTop"
          class="custom-back-top"
          @click="scrollTop()"
        >
          <Icon type="ios-arrow-up" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoinIcon from '@/components/common/CoinIcon.vue'
import Api from '@/util/api'
import Apis from '@/util/apis'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import terminal from '@/services/terminal'
import Decimal from 'decimal.js'
import Confirm from '@/components/common/Confirm'
import ConfirmRebuy from '@/components/MainPage/Terminal/ConfirmRebuyModal'
import Constants from '@/util/constants'
import Util from '@/util/util'
import TradeOrdersModal from '@/components/MainPage/Terminal/TradeOrdersModal'
import ProgressBar from '@/components/common/ProgressBar'
import OpenOrdersModal from '@/components/common/OpenOrdersModal'
import common from '@/services/common'
import EditCommentModal from '@/components/MainPage/Terminal/EditCommentModal'

export default {
  name: 'Trades',
  components: {
    Confirm,
    ConfirmRebuy,
    TradeOrdersModal,
    ProgressBar,
    OpenOrdersModal,
    EditCommentModal,
    CoinIcon
  },
  data: function () {
    return {
      isShowBackTop: false,
      symbolFilter:
        localStorage.getItem('capico_app_trade_symbol_filter') === 'true',
      confirmRebuy: false,
      tradeRebuy: {},
      confirmBtnName: '',
      confirmText: '',
      confirmSubtitle: '',
      confirmTradeId: '',
      confirmStatus: '',
      confirmCancelTradeModal: false,
      confirmCancelModal: false,
      confirmSellModal: false,
      confirmSellAllModal: false,
      confirmCancelAllTradesModal: false,
      limits: ['50', '100', '500', '1000'],
      actStatuses: [
        { en: 'ALL', ru: 'Все' },
        { en: 'SLTP', ru: 'Активные' },
        { en: 'COND', ru: 'Отложенные' },
        { en: 'ORDSUBMIT', ru: 'Ордер размещен' }
      ],
      historyStatuses: [
        { en: 'ALL', ru: 'Все' },
        { en: 'SLSELL', ru: 'Закрыта по Stop Loss' },
        { en: 'TPSELL', ru: 'Закрыта по Take Profit' },
        { en: 'PANIC', ru: 'Закрыта вручную' },
        { en: 'CLOSED', ru: 'Выключена/Отменена' },
        { en: 'ERROR', ru: 'Ошибка' }
      ],
      sides: [
        { en: 'ALL', ru: 'Все' },
        { en: 'B', ru: 'Покупка' },
        { en: 'S', ru: 'Продажа' }
      ],
      searchTxt: '',
      updateTradesInterval: null,
      updateEditTradeInterval: null,
      // tradeExt: null,
      tradeOrdersModalShow: false,
      tradeOrders: [],
      tradeSymbol: '',
      tradeComment: '',
      tradeSide: '',
      sort: {
        direction: -1,
        field: 'date'
      },
      sortBy: [
        { field: 'coin', name: 'МОНЕТА' },
        { field: 'date', name: 'ДАТА' },
        { field: 'dir', name: 'НАПРАВЛЕНИЕ' },
        { field: 'amount', name: 'СУММА' },
        { field: 'invested', name: 'ИНВЕСТИРОВАНО' },
        { field: 'price', name: 'ЦЕНА' },
        { field: 'profitusd', name: 'ПРИБЫЛЬ $' },
        { field: 'profit', name: 'ПРИБЫЛЬ %' }
      ]
    }
  },
  props: {
    advanced: Boolean
  },
  created () {
    this.$store.dispatch('updateTrades')
    this.updateTradesInterval = setInterval(() => {
      this.$store.dispatch('updateTrades')
    }, 30000)
  },
  mounted () {
    this.$refs.tableWrapper.addEventListener('scroll', event => {
      if (this.$refs.tableWrapper.scrollTop >= 800) {
        this.isShowBackTop = true
      } else {
        this.isShowBackTop = false
      }
    })

    this.$bus.$on('filterTrades', this.filterTrades)
  },
  destroyed () {
    clearInterval(this.updateTradesInterval)
    clearInterval(this.updateEditTradeInterval)
  },
  watch: {
    '$store.state.trades.data.Trades': function (value, oldValue) {
      this.filterTrades()
      this.sortList()
    },
    searchTxt: function () {
      this.filterTrades()
      this.$store.state.trades.choosenTradeIndex = -1
    },
    symbolFilter: function (filter) {
      localStorage.setItem(
        'capico_app_trade_symbol_filter',
        JSON.stringify(filter)
      )
      this.filterTrades()
      this.$store.state.trades.choosenTradeIndex = -1
    },
    '$store.state.trades.filt.type': function () {
      this.$store.state.trades.filt.stat = 'ALL'
    },
    '$store.state.trades.filt.stat': function (stat) {
      this.updateTrades()
      if (this.$store.state.trades.filt.type === 'act') {
        localStorage.setItem('trades_filter_stat', stat)
      } else {
        localStorage.setItem('trades_filter_stat', 'ALL')
      }
    },
    '$store.state.trades.filt.side': function (side) {
      this.updateTrades()
      localStorage.setItem('trades_filter_side', side)
    },
    '$store.state.sys.tradeExchange': function (newExToken) {
      this.updateTrades()
    },
    '$store.state.trades.limit': function (limit) {
      this.updateTrades()
      localStorage.setItem('trades_filter_limit', limit)
    },
    '$store.state.trades.dates': function (dates) {
      this.updateTrades()
    },
    '$store.state.sys.lastTrade': function () {
      this.updateTrades()
    },
    //   "$store.state.tradesymbol": function () {
    //     if (!this.$store.state.tradesFilter.allpairs) {
    //       this.updateBalance()
    //     }
    //   }
    '$store.state.trade.editTrade' (newTrade, oldTrade) {
      // console.log('trade changed:', newTrade, oldTrade)

      if (!newTrade) {
        // console.log('new trade is null. clear interval')
        clearInterval(this.updateEditTradeInterval)
      }

      if (oldTrade && newTrade && oldTrade.Id !== newTrade.Id) {
        // console.log('trade is changed. clear interval')
        clearInterval(this.updateEditTradeInterval)
      }

      if (newTrade) {
        // console.log('new trade. set interval')
        if (this.updateEditTradeInterval) {
          clearInterval(this.updateEditTradeInterval)
        }
        this.updateEditTradeInterval = setInterval(() => {
          terminal.tradeGetAndUpdate(newTrade.Id)
        }, 10000)
      }
    }
  },
  computed: {
    showCloseBtn () {
      if (
        this.$store.state.trades.filt.stat !== 'ALL' ||
        this.$store.state.trades.filt.side !== 'ALL' ||
        this.$store.state.trades.limit !== '50' ||
        this.$store.state.trades.dates[0] ||
        this.searchTxt !== ''
      ) {
        return true
      }
      return false
    },
    demo3: function () {
      return this.$store.state.demo
    },
    tradeType: function () {
      return this.$store.state.trades.filt.type
    },
    tradesFiltered () {
      return this.$store.state.trades.tradesFiltered
    },
    cancelableFilteredTrades () {
      return this.tradesFiltered.filter(trade => this.tradeTypeFromStatus(trade.Status) === 'act')
    }
  },
  methods: {
    saveDatePickerDates (dates) {
      localStorage.setItem('trades_filter_dates', JSON.stringify(dates))
    },
    filterTrades () {
      let list = []

      if (this.searchTxt !== '') {
        list = this.$store.state.trades.data.Trades.filter(trade => {
          if (
            trade.Symbol.toLowerCase().includes(
              this.searchTxt.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
          if (
            trade.Id.toLowerCase().includes(
              this.searchTxt.replace('#', '').toLowerCase()
            )
          ) {
            return true
          }

          if (trade.Info && trade.Info.Comment) {
            if (
              trade.Info.Comment.toLowerCase().includes(
                this.searchTxt.toLowerCase()
              )
            ) {
              return true
            }
          }
          return false
        })
      } else if (this.symbolFilter) {
        list = this.$store.state.trades.data.Trades.filter(trade => {
          if (
            trade.Symbol.toLowerCase().includes(
              this.$store.state.trade.symbol.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
        })
      } else {
        list = JSON.parse(JSON.stringify(this.$store.state.trades.data.Trades))
      }

      this.$store.state.trades.tradesFiltered = list
    },
    scrollTop () {
      this.$refs.tableWrapper.scrollTo({ top: 0, behavior: 'smooth' })
    },
    sortClicked (field) {
      this.sort.field = field
      this.sort.direction = -1 * this.sort.direction
      this.sortList()
      this.$store.state.trades.choosenTradeIndex = -1
    },
    sortList () {
      this.$store.state.trades.tradesFiltered.sort((a, b) => {
        let direction = 1
        switch (this.sort.field) {
          case 'coin':
            direction = a.Symbol > b.Symbol ? 1 : -1
            break
          case 'date':
            if (this.$store.state.trades.filt.type === 'act') {
              direction =
                new Date(a.CreatedDate) > new Date(b.CreatedDate) ? 1 : -1
            } else {
              direction =
                new Date(a.ClosedDate) > new Date(b.ClosedDate) ? 1 : -1
            }
            break
          case 'dir':
            direction = a.Side > b.Side ? 1 : -1
            break
          case 'amount':
            if (parseFloat(a.AmountLeft) === parseFloat(b.AmountLeft)) {
              direction = parseFloat(a.Amount) > parseFloat(b.Amount) ? 1 : -1
            } else {
              direction =
                parseFloat(a.AmountLeft) > parseFloat(b.AmountLeft) ? 1 : -1
            }
            break
          case 'invested':
            direction = parseFloat(a.Amount) > parseFloat(b.Amount) ? 1 : -1
            break
          case 'price':
            direction = parseFloat(a.Price) > parseFloat(b.Price) ? 1 : -1
            break
          case 'profit':
            if (
              parseFloat(a.ProfitPct) === 0 &&
              parseFloat(b.ProfitPct) === 0
            ) {
              const aPct = new Decimal(a.PriceNow)
                .sub(a.Price)
                .div(a.Price)
                .mul(100)
                .toDecimalPlaces(2)
              const bPct = new Decimal(b.PriceNow)
                .sub(b.Price)
                .div(b.Price)
                .mul(100)
                .toDecimalPlaces(2)
              direction = aPct.greaterThan(bPct) ? 1 : -1
            } else if (parseFloat(a.ProfitPct) === 0) {
              direction = 1 * this.sort.direction
            } else if (parseFloat(b.ProfitPct) === 0) {
              direction = -1 * this.sort.direction
            } else {
              direction =
                parseFloat(a.ProfitPct) > parseFloat(b.ProfitPct) ? 1 : -1
            }
            break
          case 'profitusd':
            if (
              parseFloat(a.ProfitUSD) === 0 &&
              parseFloat(b.ProfitUSD) === 0
            ) {
              const aPct = new Decimal(a.PriceNow)
                .sub(a.Price)
                .div(a.Price)
                .mul(100)
                .toDecimalPlaces(2)
              const bPct = new Decimal(b.PriceNow)
                .sub(b.Price)
                .div(b.Price)
                .mul(100)
                .toDecimalPlaces(2)
              direction = aPct.greaterThan(bPct) ? 1 : -1
            } else if (parseFloat(a.ProfitUSD) === 0) {
              direction = 1 * this.sort.direction
            } else if (parseFloat(b.ProfitUSD) === 0) {
              direction = -1 * this.sort.direction
            } else {
              direction =
                parseFloat(a.ProfitUSD) > parseFloat(b.ProfitUSD) ? 1 : -1
            }
            break
        }
        return this.sort.direction * direction
      })
    },
    profitDollarSign (value) {
      if (parseFloat(value) < 0) {
        const profit = new Decimal(value).neg().toString()
        return '-$' + profit
      }
      return '$' + value
    },
    tradeCommentShort (trade) {
      if (trade.Info && trade.Info.Comment && trade.Info.Comment.length > 20) {
        return trade.Info.Comment.substring(0, 20) + '...'
      } else if (trade.Info && trade.Info.Comment) {
        return trade.Info.Comment
      } else {
        return ''
      }
    },
    showEditCommentModal (trade) {
      this.$store.state.editCommentModal.tid = trade.Id
      this.$store.state.editCommentModal.comment = trade.Info
        ? trade.Info.Comment
        : ''
      this.$store.state.editCommentModal.show = true
    },
    showOpenOrdersModal () {
      common.getOpenOrders()
    },
    returnQuoteAsset (symbol) {
      const assets = symbol.split('_')
      return assets[1]
    },
    calcUnleveragedProfit (trade) {
      if (trade.Info && trade.Info.Leverage) {
        return new Decimal(trade.ProfitPct)
          .div(trade.Info.Leverage)
          .toDP(2)
          .toString()
      } else {
        return trade.ProfitPct
      }
    },
    returnSoPrice (trade) {
      if (trade.Sos && trade.Sos.length > 0) {
        if (trade.Status !== 'ORDSUBMIT') {
          return trade.Sos[0].Price
        } else if (trade.Sos.length > 1) {
          return trade.Sos[1].Price
        }
        return '0'
      }
      return '0'
    },
    returnTradeStepsLength (trade) {
      if (trade.Sltp && trade.Sltp.Steps) {
        return trade.Sltp.Steps.Steps.length
      }
      return 0
    },
    returnTradeCurStep (trade) {
      if (trade.Sltp && trade.Sltp.Steps) {
        return parseInt(trade.Sltp.Steps.CurStep) + 1
      }
      return 0
    },
    typeString (type) {
      return Util.typeString(type)
    },
    updateTradeOrders (trade) {
      // console.log('updateTradeOrders:', trade)
      terminal
        .tradeGet(trade.Id)
        .then(response => {
          if (response.status === Constants.http.OK) {
            // console.log('updateTradeOrders: ', response.data)
            // $store.state.trade.editTrade = response.data
            this.tradeSide = trade.Side
            if (response.data.Orders) {
              this.tradeOrders = response.data.Orders
              this.tradeSymbol = response.data.Symbol
              if (response.data.Info) {
                this.tradeComment = response.data.Info.Comment
              } else {
                this.tradeComment = ''
              }
              this.tradeOrdersModalShow = true
            } else {
              this.$Notice.info({
                title: this.$text.tr('нет ордеров'),
                duration: 1
              })
            }
          } else {
            console.log('http error. status: ', status)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    hideConfirmRebuy () {
      this.confirmRebuy = false
      // this.tradeRebuy = {}
    },
    showRebuy (trade) {
      this.confirmRebuy = true
      this.tradeRebuy = trade
    },
    resetFilter () {
      this.$store.state.trades.filt.stat = 'ALL'
      this.$store.state.trades.filt.side = 'ALL'
      this.$store.state.trades.limit = '50'
      this.$store.state.trades.dates = []
      this.searchTxt = ''
    },
    updateTrades () {
      this.$store.state.trades.loading = true
      this.$store.dispatch('updateTrades')
    },
    searchCanceled (e) {
      if (e.keyCode === 27) {
        this.searchTxt = ''
        // const elem = this.$refs.searchText
        // elem.blur()
      }
    },
    profitPctCalc (buy, sell) {
      const profit = new Decimal(sell)
        .sub(buy)
        .mul(100)
        .div(buy)
        .toDP(1)
        .toString()
      // console.log(buy + ' ' + sell  + ' ' + profit)
      return profit
    },
    tradeTypeFromStatus (status) {
      if (
        status === 'SLSELL' ||
        status === 'TPSELL' ||
        status === 'SELL' ||
        status === 'ASELL' ||
        status === 'CLOSED' ||
        status === 'ORDCANCEL' ||
        status === 'ERROR' ||
        status === 'LIQUID'
      ) {
        return 'hist'
      } else {
        return 'act'
      }
    },
    selectSymbol (symbol) {
      terminal.selectSymbol(symbol)
    },
    editTrade (trade, index) {
      this.$store.state.trades.choosenTradeIndex = index

      if (
        !this.$store.state.trade.tvEnabled &&
        this.$store.state.trade.tvLoading
      ) {
        // console.log('tv not loaded. ignore symbol change')
        return
      }
      if (this.$store.state.trades.filt.type === 'act') {
        if (!this.$store.state.trade.tvEnabled) {
          this.$store.state.trade.showTV = true
          setTimeout(() => {
            // this.$store.state.trade.editTradeId = trade.Id
            terminal.tradeGetAndSet(trade.Id)
          }, 3000)
        } else {
          this.$store.state.trade.showTV = true
          // this.$store.state.trade.editTradeId = trade.Id
          terminal.tradeGetAndSet(trade.Id)
        }
        this.$bus.$emit('open-smart-trade')
      } else {
        this.$store.state.trade.editTradeId = null
        this.$store.state.trade.editTrade = null
      }
      terminal.selectSymbol(trade.Symbol)
      // window.scrollTo(0, 0)
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    showConfirmSellAllModal () {
      this.confirmText = this.$text.tr('Закрыть все сделки по рынку') + '?'
      this.confirmBtnName = this.$text.tr('ДА')
      this.confirmSellAllModal = true
    },
    cancelAllFilteredTrades () {
      this.confirmCancelAllTradesModal = false
      this.cancelableFilteredTrades.forEach(trade => {
        this.cancelTrade(trade.Id, trade.Status)
      })
    },
    sellByMode (tradeId, actionId, symbol) {
      if (this.$store.state.sys.isNoConfirmationMode) {
        this.sell(tradeId, actionId)
      } else {
        this.showConfirmSell(tradeId, actionId, symbol)
      }
    },
    showConfirmSell (tradeId, actionId, symbol) {
      let txt = this.$text.tr('Продать по рынку?')
      let txt2 = this.$text.tr('ПРОДАТЬ')
      if (actionId === 'panicbuy') {
        txt = this.$text.tr('Выкупить по рынку?')
        txt2 = this.$text.tr('ВЫКУПИТЬ')
      }
      this.confirmText = txt
      this.confirmBtnName = txt2
      this.confirmTradeId = tradeId
      this.confirmStatus = actionId
      this.confirmSubtitle = `${symbol.replace('_', '/')} [#${tradeId}]`
      this.confirmSellModal = true
    },
    sellAll () {
      this.confirmSellAllModal = false
      const ref = this
      const params = {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id
        }
      }
      SlimApis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('trade/mass_panic', params)
        .then(response => {
          if (response.data !== null) {
            if (!response.data.err) {
              // console.log('mass panic', response.data)
              const total = response.data.Total
              const executed = response.data.Executed
              if (total !== executed) {
                ref.$Notice.warning({
                  title:
                    ref.$text.tr('Выполнено') +
                    ' ' +
                    executed +
                    ' ' +
                    ref.$text.tr('из') +
                    ' ' +
                    total,
                  duration: 10
                })
              } else {
                ref.$Notice.success({
                  title:
                    ref.$text.tr('Выполнено') +
                    ' ' +
                    executed +
                    ' ' +
                    ref.$text.tr('из') +
                    ' ' +
                    total,
                  duration: 10
                })
              }
              ref.updateTrades()
              ref.$store.state.sys.lastTrade = Date.now()
            } else {
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(error => {
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    sell (tradeId, actionId) {
      // var txt = 'Продать по рынку?'
      // if (actionId === 'panicbuy') {
      //   txt = 'Выкупить по рынку?'
      // }
      // if (confirm(txt)) {
      //   // del it!
      // } else {
      //   return
      // }
      const ref = this
      Apis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)]
        .get('trade/action?id=' + actionId + '&token=' + this.$store.state.sys.token + '&trid=' + tradeId)
        .then(function (response) {
          ref.confirmSellModal = false
          if (!response.data.err) {
            ref.$Notice.success({
              title: ref.$text.tr('Приказ создан'),
              duration: 6
            })
          } else {
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
            // disabled
            // ref.$store.dispatch('updateExchangesAsync')
          }
          ref.$store.state.sys.lastTrade = Date.now()
          // console.log(ref.symbols)
          // console.log(ref.trades)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    cancelTradeByMode (tradeId, status, symbol) {
      if (this.$store.state.sys.isNoConfirmationMode) {
        this.cancelTrade(tradeId, status)
      } else {
        this.showCancelTradeConfirm(tradeId, status, symbol)
      }
    },
    showCancelTradeConfirm (tradeId, status, symbol) {
      this.confirmBtnName = this.$text.tr('ДА')
      this.confirmTradeId = tradeId
      this.confirmStatus = status
      this.confirmSubtitle = `${symbol.replace('_', '/')} [#${tradeId}]`
      if (status !== 'ORDSUBMIT' && status !== 'COND') {
        this.confirmText = this.$text.tr('Выключить сделку?')
        this.confirmCancelTradeModal = true
      } else {
        this.confirmText = this.$text.tr('Отменить сделку?')
        this.confirmCancelModal = true
      }
    },
    cancelTrade (tradeId, status) {
      // var act = 'Отменить '
      let act2 = ' отменена'
      if (status !== 'ORDSUBMIT' && status !== 'COND') {
        // act = 'Закрыть '
        act2 = ' выключена'
      }
      // if (confirm(act + 'сделку?')) {
      //   // del it!
      // } else {
      //   return
      // }
      const ref = this
      Apis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)]
        .get('trade/action?id=close&token=' + this.$store.state.sys.token + '&trid=' + tradeId)
        .then(function (response) {
          ref.confirmCancelModal = false
          ref.confirmCancelTradeModal = false
          if (!response.data.err) {
            ref.$store.state.sys.lastTrade = Date.now()
            ref.$Notice.success({
              title: ref.$text.tr('Сделка успешно' + act2),
              duration: 6
            })
            ref.$store.dispatch('updateAssets')
          } else {
            if (response.data.err === 'timeout exceeded') {
              response.data.err =
                'Биржа не отвечает. Проверьте ордера на бирже и попробуйте еще раз'
            }
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
            // disabled
            // if (act2 === ' отменена') {
            //   ref.$store.dispatch('updateExchangesAsync')
            // }
          }
          // console.log(ref.symbols)

          // console.log(ref.trades)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    snowSlTp (index) {
      if (
        this.tradesFiltered[index].Sltp &&
        this.tradesFiltered[index].Sltp.Status === 'TPT'
      ) {
        return
      }
      const allIndex = this.$store.state.trades.data.Trades.indexOf(
        this.tradesFiltered[index]
      )
      this.$store.state.sltpIndex = allIndex
      this.$store.state.sltpTrade = true
      this.$store.state.sltpModal = true
      // this.$store.dispatch('showSlTp')
    }
  }
}
</script>
